var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "#ECF8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.3969C20.0852 19.3969 23.3969 16.0852 23.3969 12C23.3969 7.91475 20.0852 4.60303 16 4.60303C11.9148 4.60303 8.60303 7.91475 8.60303 12C8.60303 16.0852 11.9148 19.3969 16 19.3969Z",
    stroke: "#037F45",
    strokeWidth: 1.2061
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3586 10.6113C12.1962 10.7684 12.0762 10.9613 12.0065 11.1722H11.7319C11.8098 10.8965 11.9587 10.6434 12.167 10.4398C12.4757 10.1381 12.8901 9.96924 13.3217 9.96924C13.7533 9.96924 14.1677 10.1381 14.4764 10.4398C14.6847 10.6434 14.8336 10.8965 14.9115 11.1722H14.6369C14.5672 10.9613 14.4472 10.7684 14.2848 10.6113C14.0265 10.3613 13.6811 10.2216 13.3217 10.2216C12.9623 10.2216 12.6169 10.3613 12.3586 10.6113Z",
    fill: "#037F45",
    stroke: "#037F45",
    strokeWidth: 0.804066
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1339 10.6113C17.9716 10.7684 17.8516 10.9613 17.7819 11.1722H17.5073C17.5852 10.8965 17.7341 10.6434 17.9424 10.4398C18.251 10.1381 18.6655 9.96924 19.0971 9.96924C19.5287 9.96924 19.9431 10.1381 20.2517 10.4398C20.46 10.6434 20.609 10.8965 20.6868 11.1722H20.4123C20.3426 10.9613 20.2226 10.7684 20.0602 10.6113C19.8019 10.3613 19.4565 10.2216 19.0971 10.2216C18.7376 10.2216 18.3923 10.3613 18.1339 10.6113Z",
    fill: "#037F45",
    stroke: "#037F45",
    strokeWidth: 0.804066
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0624 15.5301C17.2247 15.373 17.3447 15.18 17.4144 14.9691H17.689C17.6111 15.2448 17.4622 15.4979 17.2539 15.7015C16.9453 16.0032 16.5308 16.1721 16.0992 16.1721C15.6676 16.1721 15.2532 16.0032 14.9446 15.7015C14.7363 15.4979 14.5873 15.2448 14.5095 14.9691H14.784C14.8537 15.18 14.9737 15.373 15.1361 15.5301C15.3944 15.78 15.7398 15.9197 16.0992 15.9197C16.4587 15.9197 16.804 15.78 17.0624 15.5301Z",
    fill: "#037F45",
    stroke: "#037F45",
    strokeWidth: 0.804066
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.0276a64ec58abbb1f9aeda702c46e38e.svg";
export { ForwardRef as ReactComponent };